// assets/auto-free-gift.js
(() => {
  const THRESHOLD_CENTS = 2000;
  const GIFT_VARIANT_ID = 45266143838265;
  const GIFT_QTY = 1;

  function calcEligibleSubtotalCents(cart) {
    let sum = 0;
    for (const item of cart.items || []) {
      if (item.variant_id === GIFT_VARIANT_ID) continue;
      sum += item.final_line_price;
    }
    return sum;
  }

  function findGiftLine(cart) {
    return (cart.items || []).find(i => i.variant_id === GIFT_VARIANT_ID);
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Failed to fetch cart');
    return res.json();
  }

  async function addGift() {
    await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: GIFT_QTY })
    });
  }

  async function removeGiftByKey(lineKey) {
    await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    });
  }

  let running = false;
  let lastState = null;

  async function syncGift() {
    if (running) return;
    running = true;

    try {
      const cart = await fetchCart();
      const eligibleSubtotal = calcEligibleSubtotalCents(cart);
      const qualifies = eligibleSubtotal >= THRESHOLD_CENTS;

      const giftLine = findGiftLine(cart);
      const hasGift = !!giftLine;

      const state = `${qualifies}-${hasGift}-${eligibleSubtotal}-${cart.item_count}`;
      if (state === lastState) return;
      lastState = state;

      if (qualifies && !hasGift) {
        await addGift();
        // ✅ /cart 페이지에서는 테마가 UI를 즉시 갱신 안 할 수 있어 자동 리프레시
        if (location.pathname === '/cart') setTimeout(() => location.reload(), 250);

      } else if (!qualifies && hasGift) {
        await removeGiftByKey(giftLine.key);

        // ✅ /cart 페이지에서는 자동 리프레시
        if (location.pathname === '/cart') setTimeout(() => location.reload(), 250);

      }
    } catch (e) {
      console.warn('[auto-free-gift]', e);
    } finally {
      running = false;
    }
  }

  function observeCartDomChanges() {
    const targetSelectors = ['#CartDrawer', '.cart-drawer', '[data-cart-drawer]', 'cart-drawer'];

    const getTarget = () => {
      for (const sel of targetSelectors) {
        const el = document.querySelector(sel);
        if (el) return el;
      }
      return null;
    };

    let observedEl = null;
    let observer = null;

    const attach = () => {
      const el = getTarget();
      if (!el || el === observedEl) return;

      observedEl = el;
      if (observer) observer.disconnect();

      observer = new MutationObserver(() => {
        setTimeout(syncGift, 150);
      });

      observer.observe(el, { childList: true, subtree: true });
    };

    attach();
    setInterval(attach, 2000);
  }

  function bindTriggers() {
    syncGift();

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('button[name="add"], button[type="submit"], .product-form__submit');
      if (!btn) return;
      setTimeout(syncGift, 800);
    });

    document.addEventListener('change', (e) => {
      const el = e.target;
      if (!el) return;
      if (el.name === 'updates[]' || el.matches('input[type="number"], select')) {
        setTimeout(syncGift, 600);
      }
    });

    document.addEventListener('click', (e) => {
      const cartIcon = e.target.closest('a[href="/cart"], [data-cart], .header__cart, .cart-link');
      if (!cartIcon) return;
      setTimeout(syncGift, 500);
    });

    // ✅ Cart Drawer 변경 감지 (새로고침 없이 즉시 반영)
    observeCartDomChanges();

    // (선택) 폴링은 너무 느리면 2~3초로 줄여도 됨
    setInterval(syncGift, 3000);
  }

  bindTriggers();
})();
